import LabeledElement from '@rio-cloud/rio-uikit/LabeledElement';

type ExpanderFormContentProps = {
    label: string;
    value: string | number | React.ReactNode;
    className?: string;
    classNameLabel?: string;
    classNameValue?: string;
    boxed?: boolean;
    icon?: string;
};

const LabeledValue = ({
    label,
    value,
    className,
    classNameLabel,
    classNameValue,
    boxed = false,
    icon,
}: ExpanderFormContentProps) => {
    return (
        <div className={`${className} ${boxed ? 'bg-white padding-x-15 padding-y-10 shadow-subtle rounded' : ''}`}>
            <LabeledElement label={label} noGap labelProps={{ className: classNameLabel }} />
            <div className={`text-size-14 display-flex align-items-center gap-3 ${classNameValue}`}>
                {icon && <span className={`uikit-icon icon-${icon} text-color-dark`} />}
                {value}
            </div>
        </div>
    );
};

export default LabeledValue;
